<template>
  <v-footer app padless absolute v-if="this.isShow">
    <div class="footer-wrap">
      <div>Copyright © 2023-{{ new Date().getFullYear() }} NewYoung</div>
      <div class="beian">
        <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402013744">
          <img src="../../assets/img/gongan.png" alt="" />
          <span>京公网安备 11011402013744号</span>
        </a>
        <a href="https://beian.miit.gov.cn/" target="_blank">
          <span>京ICP备2023008440号-1</span>
        </a>
      </div>
    </div>
  </v-footer>
</template>

<script>
export default {
  computed: {
    isShow() {
      // 在/message路由和404页面都不显示底部
      // 检查当前路由的组件名称是否为NotFound，或者使用其他方式判断是否为404页面
      const is404Page = this.$route.matched.some(record => record.components && record.components.default && record.components.default.name === 'NotFound');
      return this.$route.path !== "/message" && !is404Page;
    }
  }
};
</script>

<style lang="scss" scoped>
.theme--light .footer-wrap {
  background: linear-gradient(-45deg, #ee7752, #ce3e75, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: Gradient 10s ease infinite;
}
.theme--dark .footer-wrap {
  background: linear-gradient(-45deg, #0f2027, #203a43, #2c5364, #1a1a2e);
  background-size: 400% 400%;
  animation: Gradient 10s ease infinite;
}

.footer-wrap {
  width: 100%;
  line-height: 2;
  position: relative;
  padding: 40px 20px;
  color: #eee;
  font-size: 14px;
  text-align: center;

  .beian{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:10px;
    a{
      display: flex;
      align-items: center;
      color: #eeeeee;
      gap:5px;
    }
  }
}
@keyframes Gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
